<template>
  <div class="animated fadeIn">
    <b-card
      style="max-width: 1080px"
      bg-variant="light"
    >
      <div class="chart-wrapper">
        <ApexPie
          type="donut"
          :options="getOptions"
          :series="leaksFixed"
          height="310"
        />
      </div>
    </b-card>
  </div>
</template>

<script>
import Donut from "vue-apexcharts";

export default {
  name: "PieChart",
  components: {
    ApexPie: Donut,
  },
  props: ['leaksFixed', 'leaksLabels'],
  computed: {
    getOptions () {
      return {
        chart: {
          id: "pie"
        },
        colors: ["#0B1A51", "#F26C0D", "#22D2C5", "#FF5A6E"],
        yaxis: {
          labels: {
            formatter: function(value) {
              return value.toFixed(1);
            }
          }
        },
        labels: this.leaksLabels,
        title: {
          text: "Leaks Fixed",
          align: "left",
          offsetX: 110,
        },
      }
    }
  }
};
</script>
